import { render, staticRenderFns } from "./SearchPlaceholderBar.vue?vue&type=template&id=7ef2b35b&scoped=true&"
import script from "./SearchPlaceholderBar.vue?vue&type=script&lang=ts&"
export * from "./SearchPlaceholderBar.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPlaceholderBar.vue?vue&type=style&index=0&id=7ef2b35b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef2b35b",
  null
  
)

export default component.exports